




import _ from 'lodash'
import { mixins } from 'vue-class-component'
import { FilterComponentMixin } from '@/mixins/filter-component.mixin'

export default class InputFilter extends mixins(FilterComponentMixin) {
  get placeholder(): string {
    return _.get(this.filter, 'input.placeholder')
  }
}
